'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["elementData", "disabled", "connectDragSource"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import { ELEMENT, SECTION, ELEMENT_PLACEHOLDER } from 'LayoutBuilderUI/lib/DragDropConstants';
import { DragSource } from 'react-dnd-compat';
import { dragElement, dropNewElementOnPlaceholder, addNewColumn } from 'LayoutBuilderUI/actions/layoutActions';
import { dropNewElementOnSection, dropNewElementOnElement, addNewElementBeforeFooter } from 'EmailEditorUI/redux/actions/LayoutActions';
import { getModuleLoggingType } from 'EmailEditorUI/utils/usageTracking';
import { logInteraction } from 'LayoutBuilderUI/actions/ApiActions';
import { FAKE_MODULES_NAMES } from 'ContentEditorUI/constants/FakeModulesConstants';
import { DropPosition } from 'EmailEditorUI/redux/actions/types/layoutActions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withDraggableElement(WrappedComponent, storeInRecentlyUsedModules) {
  const widgetDragSource = {
    beginDrag(props, monitor, component) {
      props.dispatch(dragElement());
      return {
        moduleSpec: props.elementData,
        component,
        shouldUsePreview: false
      };
    },
    endDrag(props, monitor) {
      if (!monitor.didDrop()) {
        return;
      }
      const dropResult = monitor.getDropResult();
      const item = monitor.getItem();
      if (storeInRecentlyUsedModules) {
        storeInRecentlyUsedModules(item, props.recentlyUsedModulesList, props.isTemplateEditor);
      }
      const moduleLoggingType = props.elementData.name && props.elementData.name.toLowerCase() === FAKE_MODULES_NAMES.PAYMENTS ? FAKE_MODULES_NAMES.PAYMENTS : getModuleLoggingType(props.elementData.moduleId);
      const isAddedFromRecentlyUsed = !storeInRecentlyUsedModules;
      logInteraction({
        action: 'Modify Layout Action',
        event: 'add-module',
        'module-type': moduleLoggingType,
        'added-from-recently-used': isAddedFromRecentlyUsed
      });
      if (dropResult.type === ELEMENT) {
        if (dropResult.isVertical) {
          const index = dropResult.dropPosition === DropPosition.AFTER ? dropResult.columnIndex + 1 : dropResult.columnIndex;
          props.dispatch(addNewColumn(dropResult.sectionIndex, index, {
            moduleSpec: item.moduleSpec,
            dropPosition: dropResult.dropPosition,
            adjacentColumnIndex: dropResult.columnIndex
          }));
        } else {
          props.dispatch(dropNewElementOnElement({
            moduleSpec: item.moduleSpec,
            targetElementId: dropResult.elementId,
            dropPosition: dropResult.dropPosition
          }));
        }
      } else if (dropResult.type === SECTION) {
        props.dispatch(dropNewElementOnSection({
          moduleSpec: item.moduleSpec,
          dropPosition: dropResult.dropPosition,
          targetSectionIndex: dropResult.sectionIndex,
          forceDropOutsideBoxed: dropResult.forceDropOutsideBoxed
        }));
      } else if (dropResult.type === ELEMENT_PLACEHOLDER) {
        props.dispatch(dropNewElementOnPlaceholder({
          moduleSpec: item.moduleSpec,
          placeholderSectionId: dropResult.sectionId,
          placeholderColumnId: dropResult.columnId
        }));
      } else {
        console.error(`Unexpected element bar drop on target type ${dropResult.type}`);
      }
    }
  };
  class DraggableElementHOC extends Component {
    onDoubleClick(moduleSpec) {
      const {
        recentlyUsedModulesList,
        isTemplateEditor
      } = this.props;
      const moduleLoggingType = this.props.elementData.name && this.props.elementData.name.toLowerCase() === FAKE_MODULES_NAMES.PAYMENTS ? FAKE_MODULES_NAMES.PAYMENTS : getModuleLoggingType(this.props.elementData.moduleId);
      if (this.props.disabled) return;
      const isAddedFromRecentlyUsed = !storeInRecentlyUsedModules;
      logInteraction({
        action: 'Modify Layout Action',
        event: 'add-module-double-click',
        'module-type': moduleLoggingType,
        'added-from-recently-used': isAddedFromRecentlyUsed
      });
      if (storeInRecentlyUsedModules) {
        storeInRecentlyUsedModules({
          moduleSpec
        }, recentlyUsedModulesList, isTemplateEditor);
      }
      this.props.dispatch(addNewElementBeforeFooter({
        moduleSpec
      }));
    }
    render() {
      const _this$props = this.props,
        {
          elementData,
          disabled,
          connectDragSource
        } = _this$props,
        otherProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        onDoubleClick: () => this.onDoubleClick(elementData),
        elementData: elementData,
        disabled: disabled
      }, otherProps, {
        innerRef: el => {
          if (!disabled) {
            connectDragSource(el);
          }
        }
      }));
    }
  }
  DraggableElementHOC.propTypes = {
    elementData: PropTypes.object.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    // react-dnd
    connectDragPreview: PropTypes.func.isRequired,
    recentlyUsedModulesList: PropTypes.array.isRequired,
    isTemplateEditor: PropTypes.bool
  };
  return DragSource(ELEMENT, widgetDragSource, monitor => ({
    didDrop: monitor.didDrop(),
    dropItem: monitor.getItem()
  }))(DraggableElementHOC);
}